import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgArrowLargeLeft32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M20.853 25.142a.5.5 0 1 1-.708.707l-9.853-9.854 9.854-9.849a.5.5 0 0 1 .707.708l-9.147 9.141z" /></SvgIcon>;
};
const Memo = memo(SvgArrowLargeLeft32);
export default Memo;